import { render } from "./ShiftStats.vue?vue&type=template&id=0dec5742"
import script from "./ShiftStats.vue?vue&type=script&lang=js"
export * from "./ShiftStats.vue?vue&type=script&lang=js"

import "./ShiftStats.vue?vue&type=style&index=0&id=0dec5742&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__